module.exports = new __parcel__URL__("1st_birthday_cake_level_1_v2.02fc963d.png").toString();